import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface TriStateToggleProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  label: string;
  id?: string;
}

export const TriStateToggle = ({ value, onChange, label, id }: TriStateToggleProps) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 py-2">
      <label htmlFor={id} className="cursor-pointer font-medium text-sm">
        {label}
      </label>
      <div className="grid grid-cols-3 gap-1 bg-muted rounded-lg p-0.5 w-full sm:w-auto sm:flex sm:flex-shrink-0">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={cn(
            "px-3 py-1.5 text-xs font-medium rounded-md transition-colors text-center",
            value === true
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          Tak
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={cn(
            "px-3 py-1.5 text-xs font-medium rounded-md transition-colors text-center",
            value === false
              ? "bg-secondary text-secondary-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          Nie
        </button>
        <button
          type="button"
          onClick={() => onChange(null)}
          className={cn(
            "px-3 py-1.5 text-xs font-medium rounded-md transition-colors text-center whitespace-nowrap",
            value === null
              ? "bg-accent text-accent-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          Brak informacji
        </button>
      </div>
    </div>
  );
};
